// store/SyncContext.js
import React, { createContext, useContext, useState } from 'react';
import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';

const SyncContext = createContext();

export const SyncProvider = ({ children }) => {
    const [isSyncing, setIsSyncing] = useState(false);
    const [lastUpdateDate, setLastUpdateDate] = useState(null);

    return (
        <SyncContext.Provider value={{ isSyncing, setIsSyncing, lastUpdateDate, setLastUpdateDate }}>
            <Backdrop
                open={isSyncing}
                sx={{
                    zIndex: (t) => t.zIndex.modal + 50,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                }}
            >
                <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
                    <CircularProgress sx={{ color: '#fff' }} />
                    <Typography variant="body2" sx={{ color: '#fff' }}>
                        同步中…
                    </Typography>
                </Box>
            </Backdrop>
            {children}
        </SyncContext.Provider>
    );
};

export const useSync = () => {
    const context = useContext(SyncContext);
    if (!context) {
        throw new Error("useSync must be used within a SyncProvider");
    }
    return context;
};
